"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionControllerAsset = void 0;
const App_1 = __importDefault(require("@opsbase/lib-system/App/App"));
const Features_1 = require("@opsbase/lib-system/Features/Features");
const FeatureStatus_1 = require("@opsbase/lib-system/FeatureStatus");
const FormQuestionType_1 = __importDefault(require("../../FormQuestionType"));
const getQuestionConfig_1 = __importDefault(require("../../helpers/getQuestionConfig"));
const createFormQuestionConfigBase_1 = __importDefault(require("../../mutations/createFormQuestionConfigBase"));
const DefaultFormQuestionController_1 = __importDefault(require("../DefaultFormQuestionController"));
exports.QuestionControllerAsset = Object.assign(Object.assign({}, DefaultFormQuestionController_1.default), { compress: (q) => {
        const config = (0, getQuestionConfig_1.default)(FormQuestionType_1.default.ASSET, q);
        return { [FormQuestionType_1.default.ASSET]: config };
    }, areSame: (a, b) => {
        if (a.type !== FormQuestionType_1.default.ASSET || b.type !== FormQuestionType_1.default.ASSET)
            return false;
        if (!DefaultFormQuestionController_1.default.areSame(a, b))
            return false;
        const aConfig = a.config[FormQuestionType_1.default.ASSET];
        const bConfig = b.config[FormQuestionType_1.default.ASSET];
        if (aConfig.allowCustomText !== bConfig.allowCustomText)
            return false;
        return aConfig.allowMultiSelect === bConfig.allowMultiSelect;
    }, canScore: () => {
        return false;
    }, isAllowed(ancestors, features) {
        var _a;
        return (((_a = features === null || features === void 0 ? void 0 : features.find(f => f.name === Features_1.FeatureSets[App_1.default.OPSBASE].ASSET_MANAGEMENT.key)) === null || _a === void 0 ? void 0 : _a.state) ===
            FeatureStatus_1.FeatureStatus.ENABLED);
    }, createConfig: (o = {}) => {
        return Object.assign(Object.assign(Object.assign({}, (0, createFormQuestionConfigBase_1.default)({ scoring: exports.QuestionControllerAsset.canScore() })), { allowCustomText: false, allowMultiSelect: false }), (o || {}));
    }, createExampleConfig: () => {
        return exports.QuestionControllerAsset.createConfig({
            allowCustomText: true,
            allowMultiSelect: true,
        });
    } });
exports.default = exports.QuestionControllerAsset;
